angular.module('dnecom')
    .controller('TaxZonesController', ["$scope", "wizardModal", "Utils", "$http", "$timeout", "notifications", "$location", "ZonesUtils", function($scope, wizardModal, Utils, $http, $timeout, notifications, $location, ZonesUtils) {
        $scope.loading = false;
        $scope.error = false;
        $scope.zones = [];

        $scope.tableInstance = {};
        $scope.dtInstanceCallback = function(dtInstance)
        {
            $scope.tableInstance = dtInstance;
        };

        $scope.dtZonesColumnDefs = [{
            targets: 3,
            orderable: false,
            width: '150px'
        }];

        $scope.init = function() {
            $scope.zones = TemplateData.value('zones');
            $scope.taxClass = TemplateData.value('taxClass');
        };

        $scope.addZone = function() {
            $scope.editZone();
        };

        $scope.getZones = function() {
            $scope.loading = true;
            $http.get(Routing.generate('taxes_zones_get', {
                id: $scope.taxClass.id
            })).success(function(data) {
                if (data.hasOwnProperty('zones')) {
                    $scope.zones = data.zones;
                } else {
                    notifications.danger('Request error.');
                }
            }).finally(function() {
                $timeout(function() {
                    $scope.loading = false;
                });
            });
        };

        $scope.editZone = function(zone, index) {
            if (!zone) {
                zone = {
                    name: '',
                    countries: [],
                    taxRate: 0,
                    taxRateType: 'Sales tax',
                };
            }

            $scope.currentZone = angular.copy(zone);
            var zoneModal = wizardModal.open({
                templateUrl: 'taxZoneModal.html',
                controller: 'TaxZonesModalController',
                resolve: {
                    zone: function() {
                        return $scope.currentZone;
                    }
                }
            });

            zoneModal.result.then(function(zone) {
                $scope.saveZone(zone);
            }, function() {
                if (index && !angular.equals($scope.currentZone, $scope.zones[index])) {
                    $scope.zones[index] = $scope.currentZone;
                }
            });
        };

        $scope.saveZone = function(zone) {
            var id = 0;
            if (zone.hasOwnProperty('id')) {
                id = zone.id;
            }

            $http.put(Routing.generate('taxes_zones_update', {
                id: $scope.taxClass.id,
                zoneId: id
            }), zone)
                .then(function(response) {
                    if (response.data.success) {
                        notifications.success('Zone saved.');
                        if (id != 0) {
                            $scope.updateZone(response.data.zone);
                        } else {
                            $scope.zones.push(response.data.zone);
                        }
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function(response) {
                    notifications.danger('Request error.');
                });
        };

        $scope.deleteZone = function(zone) {
            $http.delete(Routing.generate('taxes_zones_delete', {
                id: $scope.taxClass.id,
                zoneId: zone.id
            }))
                .then(function(response) {
                    if (response.data.success) {
                        $scope.getZones();
                        notifications.success('Tax zone has been deleted.');
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function(response) {
                    notifications.danger('Request error.');
                });
        };

        $scope.updateZone = function(zone) {
            for (var i in $scope.zones) {
                if ($scope.zones[i].id == zone.id) {
                    $scope.zones[i] = zone;
                    return;
                }
            }
        };

        $scope.searchTable = function(search) {
            $scope.tableInstance.DataTable.search(search);
            $scope.tableInstance.DataTable.draw();
        };
    }]);